import {MessageCodes} from "../MessageCodes";
import Constants from "../Constants";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import ResultTable from "../../Table/ResultTable";
import EmptyLine from "../../EmptyLine";
import ResultText from "../ResultText";
import CheckCSName from "../../CheckCSName";
import OutputError from "../OutputError";

const RenderDescription = ({text, row, settings, globalVariables}) => {
    if(row.error_id === MessageCodes.Internal.SRC00.error_id) {
        return  (
            <ResultText>
                {row.error_message}
            </ResultText>
        )
    }
    else if(row.error_id === MessageCodes.Internal.TSRC001.error_id) {
        return (
            <>
                <ResultText>
                    {/*There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or lower than {settings.thresholds.delta_ws_lt} at the following {row?.data?.length} cross sections.*/}
                    There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or negative at the following {row?.data?.length} cross sections.
                    <EmptyLine />
                </ResultText>
                <ResultTable>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', minWidth: 125}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right'}}>Surcharge (ft)</ResultHeaderCell>
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {
                            (row.data || [{}]).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={r.cross_section || '{cross_section}'} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.femafw_prof_delta_ws || '{femafw_prof_delta_ws}'}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                    </ResultBody>
                </ResultTable>
            </>
        )
    }
    else if(row.error_id === MessageCodes.Internal.TSRCICS001.error_id) {
        return (
            <>
                <ResultText>
                    {/*There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or lower than {settings.thresholds.delta_ws_lt} at the following {row?.data?.length} internal cross sections.*/}
                    There are encroachment surcharges either greater than {settings.thresholds.delta_ws_gt} ft or negative at the following {row?.data?.length} internal bridge cross sections.
                    <EmptyLine />
                </ResultText>
                <ResultTable>
                    <ResultHeader>
                        <ResultRow>
                            <ResultHeaderCell style={{textAlign: 'left', minWidth: 125}}>River Station</ResultHeaderCell>
                            <ResultHeaderCell style={{textAlign: 'right'}}>Surcharge (ft)</ResultHeaderCell>
                        </ResultRow>
                    </ResultHeader>
                    <ResultBody>
                        {
                            (row.data || [{}]).map(r => {
                                return (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'left'}}><CheckCSName csName={r.cross_section || '{cross_section}'} /></ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>{r.femafw_prof_delta_ws || '{femafw_prof_delta_ws}'}</ResultBodyCell>
                                    </ResultRow>
                                )
                            })
                        }
                    </ResultBody>
                </ResultTable>
            </>
        )
    }
    else if(row.error_id === MessageCodes.Internal.B1_NOOUT01.error_id) {
        return (
            <>
                <OutputError error={row}/>
            </>
        )
    }
    else if(row.error_id === MessageCodes.Internal.B1_NOOUT02.error_id) {
        return (
            <>
                <OutputError error={row}/>
            </>
        )
    }
}

export const B1 = {
    RenderDescription
}